import styled from "styled-components";

export const Form = styled.form``;

export const FormWrapperContent = styled.div`
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  gap: 32px;

  @media (min-width: 640px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 32px 16px;
  }
`;

export const FormWrapperButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
`;
